var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  FIELD_ID_PREFIX: () => FIELD_ID_PREFIX,
  FIELD_ID_REGEXP: () => FIELD_ID_REGEXP,
  FIELD_ID_SUFFIX: () => FIELD_ID_SUFFIX,
  INPUT_ID_PREFIX: () => INPUT_ID_PREFIX,
  INPUT_ID_REGEXP: () => INPUT_ID_REGEXP,
  QUESTION_ID_PREFIX: () => QUESTION_ID_PREFIX,
  QUESTION_ID_REGEXP: () => QUESTION_ID_REGEXP,
  REQUIREMENT_ID_PREFIX: () => REQUIREMENT_ID_PREFIX,
  SUBQUESTION_ID_PREFIX: () => SUBQUESTION_ID_PREFIX,
  SUBQUESTION_ID_REGEXP: () => SUBQUESTION_ID_REGEXP,
  SYMBOL_REGEX: () => SYMBOL_REGEX,
  USER_ID_PREFIX: () => USER_ID_PREFIX,
  USER_ID_REGEXP: () => USER_ID_REGEXP,
  XML_ID_PREFIX: () => XML_ID_PREFIX,
  XML_ID_REGEXP: () => XML_ID_REGEXP,
  YAYOYAKI_ID_PREFIX: () => YAYOYAKI_ID_PREFIX,
  YAYOYAKI_ID_REGEXP: () => YAYOYAKI_ID_REGEXP,
  createError: () => createError,
  findAllParamsExpression: () => findAllParamsExpression,
  findQuestions: () => findQuestions,
  findQuestionsAndSubquestions: () => findQuestionsAndSubquestions,
  findSubquestions: () => findSubquestions,
  hashValue: () => hashValue,
  isEmpty: () => isEmpty,
  isObject: () => isObject,
  roundNumber: () => roundNumber
});
const FIELD_ID_PREFIX = "F";
const FIELD_ID_REGEXP = /(F[0-9]+C[0-9]+[A-Z]?)/g;
const FIELD_ID_SUFFIX = "C";
const INPUT_ID_PREFIX = "I";
const INPUT_ID_REGEXP = /(I[0-9]+)/g;
const QUESTION_ID_PREFIX = "Q";
const QUESTION_ID_REGEXP = /(Q[0-9]+)/g;
const REQUIREMENT_ID_PREFIX = "R";
const SUBQUESTION_ID_PREFIX = "S";
const SUBQUESTION_ID_REGEXP = /(S[0-9]+)/g;
const USER_ID_PREFIX = "U";
const USER_ID_REGEXP = /(U[0-9]+)/g;
const YAYOYAKI_ID_PREFIX = "Y";
const YAYOYAKI_ID_REGEXP = /(Y[0-9]+)/g;
const XML_ID_PREFIX = "X";
const XML_ID_REGEXP = /(X[0-9]+)/g;
const SYMBOL_REGEX = /(F[0-9]+C[0-9]+[A-Z]?)|(U[0-9]+)|(I[0-9]+)|(Q[0-9]+)|(S[0-9]+)|(Y[0-9]+)|(X[0-9]+)|(M[0-9]+)|(O[0-9]+)/g;
function createError(errorData) {
  const errorMessage = `Error: ${JSON.stringify(errorData)}`;
  return new Error(errorMessage);
}
const isObject = (object) => {
  return typeof object === "object" && object !== null;
};
function isEmpty(value) {
  if (!value || value === "0" || typeof value === "string" && value.match(/^[0][.][0]{2,}/)) {
    return true;
  }
  return false;
}
function roundNumber(value, places = 2, toHalfToward0 = false) {
  const intermediateRounded = Math.round(value + `e+${places + 10}`) + `e-${places + 10}`;
  const roundedValue = Math.round(Number(intermediateRounded) + `e+${places}`) + `e-${places}`;
  const result = Number(roundedValue);
  if (typeof value === "number" && Number.isNaN(result)) {
    return 0;
  }
  if (toHalfToward0 && Math.abs(value) % 1 === 0.5) {
    const intermediateRounded2 = Math.floor(value + `e+${places + 10}`) + `e-${places + 10}`;
    const roundedValue2 = Math.floor(Number(intermediateRounded2) + `e+${places}`) + `e-${places}`;
    return Number(roundedValue2);
  }
  return result;
}
function findQuestions(expressionString) {
  return expressionString.match(QUESTION_ID_REGEXP);
}
function findSubquestions(expressionString) {
  return expressionString.match(SUBQUESTION_ID_REGEXP);
}
function findAllParamsExpression(expressionString) {
  let params = findQuestionsAndSubquestions(expressionString);
  const yayoyakiParams = expressionString.match(YAYOYAKI_ID_REGEXP);
  if (yayoyakiParams && yayoyakiParams.length > 0) {
    params = params.concat(yayoyakiParams);
  }
  const fieldParams = expressionString.match(FIELD_ID_REGEXP);
  if (fieldParams && fieldParams.length > 0) {
    params = params.concat(fieldParams);
  }
  const inputParams = expressionString.match(INPUT_ID_REGEXP);
  if (inputParams && inputParams.length > 0) {
    params = params.concat(inputParams);
  }
  return params;
}
function findQuestionsAndSubquestions(expressionString) {
  let dependsOn = [];
  const questions = findQuestions(expressionString);
  if (questions && questions.length > 0) {
    dependsOn = dependsOn.concat(questions);
  }
  const subquestions = findSubquestions(expressionString);
  if (subquestions && subquestions.length > 0) {
    dependsOn = dependsOn.concat(subquestions);
  }
  return Array.from(new Set(dependsOn));
}
const hashValue = (text) => {
  let hash = 0;
  if (!text || text.length == 0) {
    return hash;
  }
  for (let i = 0; i < text.length; i++) {
    const char = text.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FIELD_ID_PREFIX,
  FIELD_ID_REGEXP,
  FIELD_ID_SUFFIX,
  INPUT_ID_PREFIX,
  INPUT_ID_REGEXP,
  QUESTION_ID_PREFIX,
  QUESTION_ID_REGEXP,
  REQUIREMENT_ID_PREFIX,
  SUBQUESTION_ID_PREFIX,
  SUBQUESTION_ID_REGEXP,
  SYMBOL_REGEX,
  USER_ID_PREFIX,
  USER_ID_REGEXP,
  XML_ID_PREFIX,
  XML_ID_REGEXP,
  YAYOYAKI_ID_PREFIX,
  YAYOYAKI_ID_REGEXP,
  createError,
  findAllParamsExpression,
  findQuestions,
  findQuestionsAndSubquestions,
  findSubquestions,
  hashValue,
  isEmpty,
  isObject,
  roundNumber
});
